import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21 11.255v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.88a2.625 2.625 0 1 0-2.625 2.625H12m0-2.625v2.625m0-2.625a2.625 2.625 0 1 1 2.625 2.625H12m0 0v13.5m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.622-.504-1.125-1.125-1.125h-18c-.621 0-1.125.503-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125"
    }, null, -1)
  ])))
}
export default { render: render }